module.exports = "<app-header></app-header>\n<app-loader></app-loader> \n<router-outlet></router-outlet>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/app.component.html
// module id = efyd
// module chunks = 2